module.exports = __webpack_public_path__ + "dist/media/logo--ro.0e02e822.svg";